import { Box, Flex, Img, Text, Link as ChakraLink } from "@chakra-ui/react";
import React, { useMemo } from "react";
import colors from "../../utils/colors";
import { TAppointments } from "../../apis/types";
import moment from "moment";
import { person } from "../defaultHeader/assets";
import { isFutureDay } from "../../features/patients/utils";
import { Link as RouterLink } from "react-router-dom";
interface Iprops {
  appointments: TAppointments[];
}
const UpcomingAppsCard = ({ appointments }: Iprops) => {
  const upcomingApps = appointments?.filter((app) => {
    if (isFutureDay(app?.date)) {
      return app;
    }
  });
  const groupedAppsByDate = useMemo(() => {
    const appointmentsByDate: any = {};

    upcomingApps?.slice(0, 5)?.forEach((appointment) => {
      const date = moment(appointment.date).format("Do MMM YYYY"); // Extract date part only
      if (!appointmentsByDate[date]) {
        appointmentsByDate[date] = [];
      }
      appointmentsByDate[date].push(appointment);
    });

    return appointmentsByDate;
  }, [upcomingApps]);

  return (
    <Flex
      boxShadow={"1px 4px 15px 0px #3030301F"}
      p={"24px 16px"}
      borderRadius={"8px"}
      direction={"column"}
      gap={"16px"}
      background={colors.white}
      minHeight={"150px"}
    >
      <Flex justifyContent={"space-between"} alignItems={"center"}>
        <Text
          fontWeight={700}
          fontFamily={"lato"}
          fontSize={"16px"}
          color={colors.dark}
        >
          Upcoming appointments
        </Text>

        <ChakraLink
          as={RouterLink}
          to="/appointments"
          fontWeight={400}
          fontFamily="lato"
          fontSize="12px"
          color={colors.primary}
          textDecoration="underline"
        >
          See all
        </ChakraLink>
      </Flex>

      {upcomingApps?.length === 0 ? (
        <Text
          fontWeight={400}
          fontFamily={"lato"}
          fontSize={"12px"}
          color={colors.placeholderColor}
        >
          No upcoming appointments.
        </Text>
      ) : (
        <Flex direction={"column"} gap={"20px"}>
          {Object.keys(groupedAppsByDate)?.map((key, ind) => (
            <>
              <Text
                fontWeight={400}
                fontFamily={"lato"}
                fontSize={"12px"}
                color={colors.placeholderColor}
              >
                {key}
              </Text>

              <Flex direction={"column"} gap={"12px"}>
                {groupedAppsByDate[key]?.map((app: any) => (
                  <Flex gap={"16px"} alignItems={"center"}>
                    <Img src={person} h={"40px"} w={"40px"} />
                    <Box>
                      <Text
                        fontWeight={400}
                        fontFamily={"lato"}
                        fontSize={"14px"}
                        color={colors.dark}
                      >
                        {app?.patient?.name}
                      </Text>
                      <Text
                        fontWeight={400}
                        fontFamily={"lato"}
                        fontSize={"12px"}
                        color={colors.placeholderColor}
                        mt={"4px"}
                      >
                        {moment(app?.startTime)?.format("hh:mma")}
                      </Text>
                    </Box>
                  </Flex>
                ))}
              </Flex>
            </>
          ))}
        </Flex>
      )}
    </Flex>
  );
};

export default UpcomingAppsCard;
